import { OptionItemInterface } from "../../types/interfaces";

  export const createSelectList = 
    <T extends { id?: number; name: string }>(list: T[]): OptionItemInterface[] => {
      return list.map((item) => ({
        id: String(item.id),
        label: item.name,
        name: item.name,
        value: String(item.id),
      }))
    }